import {Dispatch} from "redux";
import {endLoading, startLoading} from "../../../store/slices/loadingSlice";
import {IResponse, RACARequest} from "../../Request";
import requestMiddlewares from "../../requestMiddlewares";

export default async function(
  dispatch: Dispatch,
  filters: any,
): Promise<IResponse> {
  const request = new RACARequest('search', 'search')
    .setQueryParameters(filters);

  const response = await request.makeRequest();
  requestMiddlewares(
    dispatch,
    response,
  );

  dispatch(endLoading());

  return response;
}
